export const initialParameters = {
  segment: {
    id: 0,
    value: '',
  },
};
